export enum IncomingCallEvent {
    INCOMING_CALL_FORWARD_INITIATION = 'incoming-call-forward-initiation',
}
